import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186 186",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4 48.4c-4.5 2-9.2 8.2-10 13.3l-.6 4.3H63.5c-8.8 0-10.6.3-12.9 2.1-2.2 1.8-2.6 2.8-2.6 7.6 0 6.4 2.1 11.4 5.8 14 2.4 1.6 5.8 1.8 35.7 2.1 18.2.2 35 0 37.4-.3 3.2-.5 5.4-1.6 7.8-4 3.1-3.1 3.3-3.7 3.3-10.2 0-10.4-.4-10.7-14.4-11.1l-11.6-.4v-3c0-4.9-4.3-11.3-9.3-13.7-5-2.4-13.5-2.7-18.3-.7zm16 9.7c1.7 1.4 2.6 3 2.6 5V66H83v-2.5c0-1.4 1.1-3.7 2.5-5 3.2-3.3 11-3.5 14.9-.4zM48 111c0 14.7.2 16.2 2 18 1.9 1.9 3.3 2 42.8 2 35.3 0 41.1-.2 43-1.6 2.1-1.5 2.2-2.1 2.2-17.8V95.2l-3.7 1.9c-3 1.5-5.9 1.9-15.5 1.9H107v3.9c0 2.4-.8 4.8-2.1 6.5-1.9 2.5-2.5 2.6-11.3 2.6-11.8 0-13.6-1.1-13.6-8.1V99H68.3c-9.5 0-12.6-.4-16-2L48 95.1V111z",
    opacity: 0.9
  })));
};

export default SvgComponent;